import React, { FC, useEffect, useImperativeHandle, useRef, forwardRef } from 'react';
import styled from '@emotion/native';

import {
  TextInput as TextInputBase,
  TextInputProps
} from 'react-native';
import TextBase, { Props as TextProps } from '@components/1-atoms/Text';
import { Spacer } from '@components/1-atoms/Miscellaneous';
import { useTheme } from '@emotion/react';
import * as utils from '@lib/utils';

const View = styled.View``;

export const Container = styled.TouchableOpacity`
  border-color: #C0C0C0;
  border-radius: 5px;
  border-bottom-width: 1.3px;
  border-width: 1.3px;
  flex-direction: row;
  justify-content: space-evenly;

  width: ${({ autowidth, width, theme }: any) =>
    (autowidth && `auto`) || (width && `${width}px`) || `${theme.contentWidth - 30}px`
  };

  ${props => (props.mini) && `
    width: ${props.theme.columnWidth - 2 - 15}px;
  `}
  
  ${props => props.opaque && `background-color: #0058d10a;`}
  
  ${props => (props.border === false) && `
    border-bottom-width: 0;
    border-width: 0;
  `}
`;

// padding: 0 6px;
// padding: ${({ mini }: any) => mini ? `0`  `0 6px` };
export const Right = styled.View`
  align-items: center;
  flex-grow: 0;
  justify-content: center;
  padding: 0 9px;
  max-width: 50px;
`;
export const Left = styled(Right)``;

export const Content = styled.View`
  flex: 1000;
  padding-left: 3px;
`;

export const TextInput = styled(TextInputBase)`
  color: ${(props: any) => props.color || props.theme.colors.dark};
  font-weight: ${(props: any) => props?.weight || 'normal'};
  font-size: ${(props: any) => `${props.size || props.theme.fontSize}px`};
  padding: ${({ padding = true }: any) => `${padding ? "6px 12px" : 0}`};
  text-align: ${({ textalign = 'justify' }: any) => `${textalign}`};
  height: ${({ multiline, height = 39 }: any) => `${multiline ? height : 39}px`};
`;

export const Text = styled(TextBase)``;

const Input: FC<Props> = forwardRef(({ onPress, defaultValue, inputMode, onChange, onBlur, label, required, accent, left, right, style, size = 16, height, ...props }, ref) => {

  const theme = useTheme();
  ref = ref || useRef({});

  const [text, setText] = React.useState(
    (inputMode?.localeCompare("decimal") === 0) ? utils.printDecimalOf(defaultValue) : defaultValue
  );

  useEffect(() => {
    //@ts-ignore
    if (ref.current && ref.current.isFocused && !ref.current.isFocused()) {
      setText((inputMode?.localeCompare("decimal") === 0) ? utils.printDecimalOf(defaultValue) : defaultValue);
    } else {
      setText(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if ((inputMode?.localeCompare("decimal") === 0) || (inputMode?.localeCompare("numeric") === 0)) {
      onChange?.((text?.length ? parseFloat(text) : 0));
    } else {
      onChange?.(text?.length ? text : null);
    }
  }, [text]);

  const _onBlur = () => {
    if (inputMode?.localeCompare("decimal") === 0) {
      setText(utils.printDecimalOf(text));
    }
    onBlur?.();
  }

  const textLegth = Math.max(text?.length || 0, props.placeholder?.length || 0);
  // @ts-ignore
  height = Math.max(Math.floor((size * textLegth / 2) / theme.contentWidth) * 39, 90);

  return (
    <View>

      {label?.length ? <Text color='#000' small>{label} {required && <Text small color="#F00"> *</Text>} </Text> : null}
      <Spacer h={0.5} />

      <Container onPress={onPress} style={style} {...props}>
        {left ? <Left>{left}</Left> : null}

        <Content>
          <TextInput
            ref={ref}
            size={size}
            height={height}
            onBlur={_onBlur}
            inputMode={inputMode}
            placeholderTextColor="#C0C0C0"
            color={"#000000"}
            autoComplete="off"
            onChangeText={setText}
            value={text || ''}
            {...props}
          />
        </Content>

        {right ? <Right>{right}</Right> : null}
      </Container>

    </View>
  );
});


export type Props =/*  TextInputProps & */ TextProps & {
  onPress?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  onSubmitEditing?: () => void;
  placeholder?: string;
  width?: number | string;
  height?: number;
  left?: any;
  right?: any;
  autowidth?: boolean;
  opaque?: boolean;
  mini?: boolean;
  size?: number;
  label?: string;
  required?: boolean;
  editable?: boolean;
  autoComplete?: string;
  style?: object;

  border?: boolean;
  padding?: boolean;
  weight?: string;

  accent?: string;
  keyboardType?: string;
  inputMode?: string;
  autoCapitalize?: string;
  textalign?: string;
  selectTextOnFocus?: boolean;
  multiline?: boolean;
  ref?: any;

  defaultValue?: string | null | undefined;
  onChange?: (value: string | null | undefined | any) => void;
};

export default Input;